// Search box and header positioning functions

export function moveSearchBoxToBottom() {
    const searchBox = document.getElementById('searchBox');
    const textarea = document.getElementById('searchInput');
    if (searchBox && !searchBox.classList.contains('bottom-positioned')) {
        searchBox.classList.remove('centered');
        searchBox.classList.add('bottom-positioned');
        // Show share button for Pro users when searchbox is bottom-positioned
        const shareResearchBtn = document.getElementById('shareResearchBtn');
        const userAccountTier = document.getElementById('userAccountTier');
        const isPro = userAccountTier && userAccountTier.textContent && userAccountTier.textContent.trim() === 'Pro';
        if (shareResearchBtn && isPro) {
            shareResearchBtn.style.display = 'flex';
            shareResearchBtn.classList.add('show');
        }
        // Always set min-height to single-line pill height when moved to bottom
        // handleSearch will set the actual height after clearing the value
        if (textarea) {
            textarea.style.setProperty("min-height", "56px", "important");
            if (!textarea.value.trim() && document.activeElement !== textarea) {
                textarea.style.setProperty("height", "56px", "important");
                textarea.style.setProperty("padding-bottom", "14px", "important");
                textarea.style.setProperty("overflow", "hidden", "important");
            }
        }
        
        // Update scroll and share button position after search box is moved
        if (window.innerWidth <= 650) {
            requestAnimationFrame(() => {
                const scrollToBottomBtn = document.getElementById('scrollToBottomBtn');
                const shareResearchBtn = document.getElementById('shareResearchBtn');
                if (scrollToBottomBtn || shareResearchBtn) {
                    const searchBoxRect = searchBox.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const spacing = 12;
                    const bottomPosition = windowHeight - searchBoxRect.top + spacing;
                    const shareGap = 56; // scroll button height + gap so share sits above
                    if (scrollToBottomBtn) scrollToBottomBtn.style.bottom = `${bottomPosition}px`;
                    if (shareResearchBtn) shareResearchBtn.style.bottom = `${bottomPosition + shareGap}px`;
                }
            });
        }
    }
}

export function moveHeaderBoxToTop() {
    const headerBox = document.getElementById('headerBox');
    if (headerBox && !headerBox.classList.contains('top-positioned')) {
        headerBox.classList.remove('centered');
        headerBox.classList.add('top-positioned');
    }
}
